export const COMPANY_NAME = 'Sport Data Collection';
export const COMPANY_NAME_GROUP = COMPANY_NAME + ' Group';
export const COMPANY_ABBR = 'SDC';
export const COMPANY_ABBR_GROUP = COMPANY_ABBR + ' Group';

export const COMPANY_EMAIL = 'office@sportdatacollection.com';
export const COMPANY_WWW = 'https://sportdatacollection.com';


export const INVOICE_ACCOUNT = 'BG53STSA93000029013970';
export const INVOICE_BANK = 'DSK Bank 19 Moskovska Str., Oborishte District, Sofia 1036, Bulgaria';
export const INVOICE_SWIFT = 'STSABGSF';
export const INVOICE_VAT_ID = '2894319839';
export const INVOICE_RECIPIENT = 'YEVHENII TARASOV';
export const INVOICE_RECIPIENT_2 = 'Sport Data Collection Ltd.';
export const INVOICE_REGISTRATION_ADDRESS = 'Ukraine, 65490, Odesa region, Teplodar, Enerhetykiv St., 83/44';

export const INVOICE_AMOUNT_BASIC_MONTH = 10;
export const INVOICE_AMOUNT_BASIC_YEAR = 100;
export const INVOICE_AMOUNT_STANDARD_MONTH = 500;
export const INVOICE_AMOUNT_STANDARD_YEAR = 5000;
export const INVOICE_AMOUNT_PREMIUM_MONTH = 2000;
export const INVOICE_AMOUNT_PREMIUM_YEAR = 20000;

export const INVOICE_AMOUNT_BASIC_MONTH_TEXT = 'Ten';
export const INVOICE_AMOUNT_BASIC_YEAR_TEXT = 'One hundred';
export const INVOICE_AMOUNT_STANDARD_MONTH_TEXT = 'Five hundred';
export const INVOICE_AMOUNT_STANDARD_YEAR_TEXT = 'Five thousand';
export const INVOICE_AMOUNT_PREMIUM_MONTH_TEXT = 'Two thousand';
export const INVOICE_AMOUNT_PREMIUM_YEAR_TEXT = 'Twenty thousand';
